import React from 'react'

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 16"><g stroke="currentColor" fill="none" fillRule="evenodd"><path strokeLinecap="square" d="M.5 8h24"/><path strokeLinecap="round" strokeLinejoin="bevel" d="M18.136.929L25.207 8l-7.071 7.071"/></g></svg>
)

export default ArrowRight
